import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('TasksList').create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'start',
    width: '100%',
    overflow: 'hidden',
    borderRadius: '12px',
  },

  tabList: {
    width: '90%',
    display: 'flex',
    flexDirection: 'row',
    borderRadius: '8px',
    minHeight: '32px',
    maxHeight: '45px',
    backgroundColor: '#B0B1B81F',
    '.MuiTabs-flexContainer': {
      justifyContent: 'space-between',
    },
    button: {
      borderRadius: '7px',
      color: 'white',
      padding: '3px 10px',
      textTransform: 'none',
      width: '50%',
      minHeight: '32px',
      fontFamily: 'Inter',
      fontWeight: '550',
      fontSize: theme.sizes.texts.fontSize.s,
      '&.Mui-selected': {
        backgroundColor: '#FFFFFF29',
        color: 'white',
        border: '0.5px solid rgba(0, 0, 0, 0.5)',
        boxShadow: '0px 3px 8px 0px rgba(0, 0, 0, 0.12), 0px 3px 1px 0px rgba(0, 0, 0, 0.04)',
      },
    },
    span: {
      display: 'none',
    },
  },
}))
